import {Modal, Button} from 'react-bootstrap'
import {IKanbanStage} from '../../../types/kanban'

interface Props {
  show: boolean
  stage?: IKanbanStage | null
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ModalDeleteKanbanStage: React.FC<Props> = ({show, stage, loading, onClose, onConfirm}) => {
  return (
    <Modal show={show} onHide={onClose} centered className='kanban-stage-delete-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar columna</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        ¿Seguro que deseas eliminar la columna <strong>{stage?.name}</strong>? Esta acción no se puede deshacer.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant='danger' onClick={onConfirm} disabled={loading}>
          {loading ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
